import { FormControl, FormControlLabel, Grid, Link, MenuItem, Pagination, Radio, RadioGroup, Select, TextField, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import OZCheckbox from '../../../../OZCheckbox/OZCheckbox';
import './FilterDrawer.css';
import { FixedSizeList as List } from 'react-window';
import { useLocation } from 'react-router-dom';
import WidgetSearchV2 from '../../../../Widget-Search/Widget-SearchV2';

type Props = {
	selectedFilters?: any;
	handleOnCheckboxChange?: any;
	filterList?: any;
	groupName?: any;
	handleDurationinSecs?: any;
	singleSelect?: any;
	handleOnRadioChange?: any;
	handleDurationInputChange?: any;
	durationValue?: any;//::::::::::::::::::::for Duration testing:::::::::::::::::::::::::::://
	durationinSecs?: any//::::::::::::::::::::for Duration testing:::::::::::::::::::::::::::://
	name?: any;
	dispositionDisabledToolTip?: any;
	handleSelectAll?: any;
	handleClearAll?: any;
	forceSelectAll?: any;
	showAgentId?: any;
};

const FilterAccordianContent = ({ filterList, name, dispositionDisabledToolTip, groupName, selectedFilters, handleOnCheckboxChange, handleDurationinSecs, singleSelect, handleOnRadioChange, handleDurationInputChange, durationValue, durationinSecs, handleSelectAll, handleClearAll, forceSelectAll = false, showAgentId = false }: Props) => { //::::::::::::::::::::for Duration testing:::::::::::::::::::::::::::://

	const location = useLocation();

	const getData = () => {
		try {
			let parsedData;
			const prevGroupName = localStorage.getItem('prevGroupName');
			if (prevGroupName !== (location.pathname + groupName)) {
				return null;
			}
			let data = localStorage.getItem('FilteredData');
			if (data) {
				parsedData = JSON.parse(data);
			}
			return parsedData;
		} catch (error) {
			console.error('Error parsing JSON:', error);
			return null;
		}
	}

	const getSearchInput = () => {
		try {
			const prevGroupName = localStorage.getItem('prevGroupName');
			if (prevGroupName !== (location.pathname + groupName)) {
				return null;
			}
			let data = localStorage.getItem('searchInput');
			return data || '';
		} catch (error) {
			console.error('Error parsing JSON:', error);
			return null;
		}
	}

	const [filterItems, setFilterItems] = useState<any>(getData() || filterList);
	const [newValue, setNewValue] = useState<any>(durationValue);
	const [page, setPage] = useState(Number(localStorage.getItem('currentPage') || 1));
	const itemsPerPage = 200;
	const [searchInput, setSearchInput] = useState<any>(getSearchInput());

	useEffect(() => {
		localStorage.setItem('currentPage', page.toString());
	}, [page]);

	useEffect(() => {
		const prevGroupName = localStorage.getItem('prevGroupName');
		if (prevGroupName !== (location.pathname + groupName)) {
			setPage(1);
			localStorage.setItem('prevGroupName', location.pathname + groupName);
			localStorage.removeItem('FilteredData');
			localStorage.setItem('searchInput', '');
		}
	}, [groupName]);

	const handleSearch = (event: any) => {
		try {
			const searchText = event?.target?.value;
			setSearchInput(searchText);
			localStorage.setItem('searchInput', searchText);
			if (searchText?.length) {
				let filteredData = [];
				if (showAgentId) {
					try {
						filteredData = filterList.filter((item: any) => {
							if (item.name === "All" || item.name === null || !item.name) {
								return false;
							}
							const lowerCaseSearch = searchText.toLowerCase();
							const inName = item.name.toLowerCase().includes(lowerCaseSearch);
							if (showAgentId) {
								const inValue = item.value?.toLowerCase().includes(lowerCaseSearch);
								return inName || inValue;
							}
							return inName;
						});
					}
					catch (e) {
						filteredData = filterList.filter((item: any) => item.name !== "" && item.name !== "All" && item.name !== null && item.name && item.name.toLowerCase().includes(searchText.toLowerCase()));
						console.log("Error in handleSearch", e)
					}
				} else {
					filteredData = filterList.filter((item: any) => item.name !== "" && item.name !== "All" && item.name !== null && item.name && item.name.toLowerCase().includes(searchText.toLowerCase()));
				}
				setFilterItems(filteredData);
				localStorage.setItem('FilteredData', JSON.stringify(filteredData));
				setPage(1);
			} else {
				setFilterItems(filterList);
				localStorage.setItem('FilteredData', JSON.stringify(filterList));
			}
		} catch (error) {
			console.error('Error handling search:', error);
		}
	};

	const finalCallTheInput = (value: any) => {
		handleDurationInputChange(value);
	}

	const changeEvent = (event: any) => {
		if (event === '') {
			finalCallTheInput('');
		}
		setNewValue(event);
	}

	const handleOnChange = (event: any) => {
		handleDurationinSecs(event.target.value);
	};

	const isChecked = (item: any, groupName: string) => {
		if (selectedFilters[groupName]?.length) {
			return selectedFilters[groupName].some((filterItem: any) => item.id === filterItem.id || item.value === filterItem.id);
		} else {
			return false;
		}
	};

	function getDisabled(name: any, item: any, group: any) {
		if (name === 'Daily Call Summary' && group === 'dateFormat' && (item.value === '1' || item.name === 'DATE')) {
			return true;
		} else {
			return false;
		}
	}

	function getDefaultValueForRadio(name: any, group: any) {
		if (name === 'Daily Call Summary' && group === 'dateFormat') {
			return '1';
		} else {
			return null;
		}
	}

	const selectAll = () => {
		try {
			let selectedFilterItems = filterItems.map(((item: { id: any; name: any; value: any }) => {
				return {
					id: item.id || item.value,
					label: item.name,
					group: groupName
				}
			}));
			handleSelectAll(selectedFilterItems, groupName);
		} catch (error) {
			console.error('Error in selectAll:', error);
		}
	}

	const clearAll = () => {
		try {
			let selectedFilterItems = filterItems.map(((item: { id: any; name: any; value: any }) => {
				return {
					id: item.id || item.value,
					label: item.name,
					group: groupName
				}
			}));
			handleClearAll(selectedFilterItems, groupName);
		} catch (error) {
			console.error('Error in clearAll:', error);
		}
	}

	const getFilterItemListElements = (filterGroup: any[], groupName: string) => {
		if (groupName === 'durationinsecs') {
			return (
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<div className="ozonetel-form-control" style={{ marginLeft: '20px' }}>
						<label className="form-label">Duration(in sec)</label>
						<Select value={durationinSecs} onChange={handleOnChange} style={{ width: '200px', height: '45px' }}>
							{filterGroup.map((duration: any) => (
								<MenuItem key={duration.name} value={duration.value}>
									{duration.name}
								</MenuItem>
							))}
						</Select>
					</div>
					{durationinSecs !== 'All' &&
						<div style={{ marginLeft: '8px', marginTop: '21px' }}>
							<label style={{ fontSize: '12px', fontWeight: '400' }}>Enter Value*</label>
							<TextField
								sx={{
									'& .MuiOutlinedInput-root': {
										borderRadius: '8px',
										backgroundColor: '#ffff',
										fontSize: '12px',
										height: '46px',
										width: '180px',
									},
									'& .MuiOutlinedInput-notchedOutline': {
										border: '1px solid #D6D6D7'
									},
									'& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
										backgroundColor: '#D6D6D7',
										border: '1px solid #D6D6D7'
									}
								}}
								type='number'
								onChange={(event) => { changeEvent(event?.target?.value) }}
								onBlur={(event) => { finalCallTheInput(event?.target?.value) }}
								onKeyDown={(event) => {
									if (event.key === 'Enter' || event.key === 'Tab') {
										event.preventDefault();
										finalCallTheInput(newValue);
									}
								}}
								value={newValue}
								id='outlined-basic'
							/>
						</div>
					}
				</div>
			);
		}

		if (singleSelect?.includes(groupName)) {
			const startIndex = (page - 1) * itemsPerPage;
			const paginatedItems = filterGroup.slice(startIndex, startIndex + itemsPerPage);

			return (
				<FormControl>
					<RadioGroup
						onChange={(e: any) => {
							handleOnRadioChange(e, groupName);
						}}
						defaultValue={getDefaultValueForRadio(name, groupName)}
						value={selectedFilters[groupName]?.id}
						style={{ marginLeft: '30px' }}
					>
						{paginatedItems.map((item: any) => (
							<FormControlLabel
								disabled={getDisabled(name, item, groupName)}
								key={item.id || item.value}
								value={item.id || item.value}
								control={<Radio />}
								label={item.name}
								name={item.name}
							/>
						))}
						{filterGroup.length > itemsPerPage && (
							<Grid container justifyContent="center" sx={{ pt: '10px' }}>
								<Pagination
									count={Math.ceil(filterGroup.length / itemsPerPage)}
									page={page}
									onChange={(e, value) => setPage(value)}
								/>
							</Grid>
						)}
					</RadioGroup>
				</FormControl>
			);
		}

		// For checkbox lists with pagination
		const startIndex = (page - 1) * itemsPerPage;
		const paginatedItems = filterGroup.slice(startIndex, startIndex + itemsPerPage);

		const renderFilterItem = ({ index, style }: any) => {
			const item = paginatedItems[index];
			return (
				<div style={style}>
					<Tooltip title={dispositionDisabledToolTip ? "Maximum of 100 select dispositions are allowed in the Disposition filter" : ""}>
						<Grid container alignItems="center" className="filter-checkbox-col" spacing={2} xs={10} sx={{ marginLeft: 4 }}>
							<Grid item xs={showAgentId ? 12 : 9} style={{ display: 'flex', alignItems: 'center' }}>
								<OZCheckbox
									checked={isChecked(item, groupName)}
									label={item.name}
									chipValue={showAgentId ? item?.value : null}
									group={groupName}
									id={item.id || item.value}
									onChange={(e: any) => handleOnCheckboxChange(e)}
								/>
							</Grid>
						</Grid>
					</Tooltip>
				</div>
			);
		};

		return (
			<>
				{/* Select All / Clear All Links */}
				{(searchInput?.length > 0 || forceSelectAll) && filterItems?.length > 0 && (
					<Grid container>
						<Grid item xs={12}>
							<div className="filter-select-links" style={{ marginLeft: '20px', marginBottom: '2px', marginTop: '5px' }}>
								<Link onClick={() => selectAll()} underline="hover">
									Select All
								</Link>
								<Link onClick={() => clearAll()} underline="hover">
									Clear All
								</Link>
							</div>
						</Grid>
					</Grid>
				)}

				{/* Virtualized List for current page items */}
				<List
					height={400}
					itemCount={paginatedItems.length}
					itemSize={50}
					width={'100%'}
				>
					{renderFilterItem}
				</List>

				{/* Pagination */}
				{filterGroup.length > itemsPerPage && (
					<Grid container justifyContent="center" className="sticky-pagination" sx={{ pt: '10px' }}>
						<Pagination
							count={Math.ceil(filterGroup.length / itemsPerPage)}
							page={page}
							onChange={(e, value) => setPage(value)}
						/>
					</Grid>
				)}
			</>
		);
	};

	return (
		<div>
			{groupName !== 'durationinsecs' && (
				<Grid item>
					<WidgetSearchV2 onTextChange={handleSearch} searchInput={searchInput}></WidgetSearchV2>
				</Grid>
			)}

			<div>
				<Box className="filter-accordion-items-container" sx={{ marginTop: '10px' }}>
					<Grid container spacing={2}>
						{getFilterItemListElements(filterItems, groupName)}
					</Grid>
				</Box>
			</div>
		</div>
	);
};
export default FilterAccordianContent;